var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2493_28940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122 64V127H8V64",
    stroke: "#141225",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9674 21.6666C61.9674 21.6666 61.5339 16.8998 53.3006 8.23312C45.0673 -0.433543 29.6063 -0.00010262 24.2674 9.53322C18.9285 19.0665 28.1676 29.4665 32.5009 32.0665",
    stroke: "#7971F6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0339 21.6665C67.0339 21.6665 68.7672 16.4665 76.5672 7.79985C84.3672 -0.866815 97.7822 0.000397533 103.121 9.53372C108.46 19.067 99.221 29.4671 94.8877 32.0671",
    stroke: "#7971F6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2842 32.0664V28.0581C58.2842 24.5281 61.1458 21.6664 64.6758 21.6664V21.6664C68.2059 21.6664 71.0675 24.5281 71.0675 28.0581V32.0664",
    stroke: "#7971F6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5186 64.0026L127.997 64.0026L127.997 32.0125L2.00049 32.0158L2.00064 63.802L28.7532 64.0025",
    stroke: "#141225",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.8672,
    y1: 64.5,
    x2: 88.4005,
    y2: 64.5,
    stroke: "#141225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 127V32",
    stroke: "#141225",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.6001,
    y: 32,
    width: 11,
    height: 95,
    stroke: "#7971F6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.3999,
    y: 32,
    width: 11,
    height: 95,
    stroke: "#7971F6",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2493_28940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrize);
export default __webpack_public_path__ + "static/media/prize.7336b414606ebd5a5a26cd382bce6866.svg";
export { ForwardRef as ReactComponent };